import { lazy } from 'react';

// project-imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import AuthGuard from '../layout/Auth/AuthGuard';
// import DashboardSwitcher from '../layout/Dashboard/user-flow/DashboardSwitcher';
// render - dashboard pages
const DashboardSwitcher = Loadable(lazy(() => import('../layout/Dashboard/user-flow/DashboardSwitcher')));

// ==============================|| NAVIGATION ROUTING ||============================== //

const NavigationRoutes = {
  path: '/',
  element: <AuthGuard allowedRoles={['SUPER_ADMIN', "ADMIN"]} />,
  children: [
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        {
          path: '/',
          element: <DashboardSwitcher  />
        }
      ]
    }
  ]
};

export default NavigationRoutes;
